import { render, staticRenderFns } from "./TabBarItem.vue?vue&type=template&id=c3bedd8e&scoped=true&"
import script from "./TabBarItem.vue?vue&type=script&lang=ts&"
export * from "./TabBarItem.vue?vue&type=script&lang=ts&"
import style0 from "./TabBarItem.vue?vue&type=style&index=0&id=c3bedd8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bedd8e",
  null
  
)

export default component.exports